import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React, { useState, useEffect } from 'react';
import { Space, Skeleton, Empty, Select } from 'udesk-ui';
import Page from 'Component/common/udesk-qa-page-layout';
import LayoutCard from './components/LayoutCard';
// import BalanceCard from './components/BalanceCard';
import NumericalCard from './components/NumericalCard';
import Trend from './components/Trend';
import { postInspectionVocHomePageQueryVocOverView } from 'src/api/inspectionVocHomePage/queryVocOverView';
import moment from 'moment';
import './style.scss';

const commonParams = {
    beginOfWeek: '1',
    endOfWeek: '7',
    task_id: '-1',
    inspect_data_source: '-1',
    permission: 'all',
    agent_no: "'-1'",
    companyId: 5,
};

const Template = React.memo((props: any) => {
    const { sdkOptions } = props;
    const locales = UdeskLocales['current'];
    const { company, user } = Udesk.data.init;
    const [overviewData, setOverviewData] = useState<any[]>([]);
    const [overviewDataLoading, setOverviewDataLoading] = useState<boolean>(true);

    useEffect(() => {
        postInspectionVocHomePageQueryVocOverView({
            ...commonParams,
            statAt: [
                moment().add(-1, 'day').format('YYYY-MM-DD 00:00:00'),
                moment().add(-1, 'day').format('YYYY-MM-DD 23:59:59'),
            ],
        })
            .then((resp: any) => {
                let ret: any[] = [];
                // let subIndex = 0;
                resp?.data &&
                    resp.data.rows &&
                    resp.data.rows.forEach((item, index) => {
                        ret.push({
                            icon: 'icon_zhijianzongshu',
                            name: item.description,
                            data: item.value,
                        });
                    });
                setOverviewData(ret);
            })
            .finally(() => {
                setOverviewDataLoading(false);
            });
    }, []);

    const [dataParams, setdataParams] = useState<Record<string, any>>({
        ...commonParams,
        statAt: [
            moment().add(-7, 'day').format('YYYY-MM-DD 00:00:00'),
            moment().add(-1, 'day').format('YYYY-MM-DD 23:59:59'),
        ],
    });

    return (
        <Page
            pageBodyClassName="dashboard-page-index"
            title={locales.pages.dashboard.title}
            // padding={true}
            backGroundGhost={true}
        >
            <div className="dashboard-page-card space-between header">
                <Space>
                    <div className="logo">
                        <img src="/static/images/qa-logo.png" alt="" />
                    </div>
                    <div>
                        <div className="title">{`${locales.pages.dashboard.hi}${user.realname}`}</div>
                        <Space style={{ marginTop: 11 }}>
                            <div className="company">{`@${company.sysName}`}</div>
                            <div className="edition">{locales.pages.dashboard.standardEdition}</div>
                        </Space>
                    </div>
                </Space>

                <div className="billing-module">
                    {/* <div>
                        <Space split={<Divider type="vertical" />} style={{ marginRight: 8 }}>
                            <BalanceCard
                                title={'评论分析余额'}
                                value={accountCharge.balance}
                                isWarning={accountCharge.callWarning}
                            />
                            <BalanceCard
                                title={'语音分析余额'}
                                value={accountCharge.balance}
                                isWarning={accountCharge.callWarning}
                            />
                            <BalanceCard
                                title={'产品有效期'}
                                value={accountCharge.deadline}
                                isWarning={accountCharge.ImWarning}
                            />
                        </Space>
                    </div> */}
                </div>
            </div>

            {Udesk.data.init.company.id !== 309 ? (
                <React.Fragment>
                    <LayoutCard
                        title={locales.pages.dashboard.yesterdayOverView}
                        loading={overviewDataLoading}
                        fallback={<Skeleton />}
                    >
                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {overviewData.length ? (
                                overviewData.map((item) => <NumericalCard {...item} />)
                            ) : (
                                <Empty
                                    style={{ margin: '0 auto', minHeight: 136 }}
                                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                                />
                            )}
                        </div>
                    </LayoutCard>

                    <LayoutCard
                        title={
                            /* 近期数据趋势统计 */ UdeskLocales['current'].pages
                                .conversationAnalysis.dashboard.index.recentDataTrendStatistics
                        }
                        loading={false}
                        fallback={
                            <Space>
                                <Skeleton />
                                <Skeleton />
                            </Space>
                        }
                        extra={
                            <Select
                                defaultValue={7}
                                options={[
                                    {
                                        value: 7,
                                        label: /* 最近7天 */ UdeskLocales['current'].components
                                            .common.datePicker.lastSevenDay,
                                    },
                                    {
                                        value: 30,
                                        label: /* 最近30天 */ UdeskLocales['current'].components
                                            .common.datePicker.lastThirtyDay,
                                    },
                                ]}
                                onChange={(v) => {
                                    setdataParams((p) => {
                                        return {
                                            ...p,
                                            statAt: [
                                                moment()
                                                    .add(-v, 'day')
                                                    .format('YYYY-MM-DD 00:00:00'),
                                                moment()
                                                    .add(-1, 'day')
                                                    .format('YYYY-MM-DD 23:59:59'),
                                            ],
                                        };
                                    });
                                }}
                            />
                        }
                    >
                        <Trend sdkOptions={sdkOptions} chartDataParams={dataParams} />
                    </LayoutCard>
                </React.Fragment>
            ) : null}
        </Page>
    );
});

class Component extends React.Component {
    render() {
        return <Template {...this.props} />;
    }
}

export default Udesk.react.udeskify(Component);
